<template>
  <div v-if="question" class="question-title">
    <h2 class="question-choice">{{ question.intro }}</h2>

    <div class="my-3 search">
      <input
        v-model="searchQuery"
        type="text"
        class="search-bar"
        placeholder="Nach einer Antwort suchen.."
      >
      <b-button variant="dark" class="search-button" v-on:click="updateVModel(searchQuery)">
        <i class="fas fa-search"></i>
      </b-button>
    </div>

    <!-- Antworten mit Bild (Top-Antworten) -->
    <grid-option-list :option-list="topOptionsList" v-if="topOptionsList.length !== 0"/>

    <grid-option-list :option-list="optionList" />
  </div>
</template>

<script>
import GridOptionList from '../diagnosis/GridOptionList'

export default {
  name: 'SearchQuestion',
  components: {
    GridOptionList
  },
  data () {
    return {
      openedModal: null,
      search: '',
      searchQuery: '',
      options: this.$store.state.questions[0].config.options
    }
  },
  computed: {
    topOptionsList () {
      const options = this.options.filter((option) => {
        return (
          option.title
            .toLowerCase()
            .includes(this.search.toLowerCase()) && option.image
        )
      })
      return options
    },
    optionList () {
      const options = this.options.filter((option) => {
        return (
          option.title
            .toLowerCase()
            .includes(this.search.toLowerCase()) && !option.image
        )
      })
      return options
    },
    question: function () {
      return this.$store.state.questions[0] || false
    }
  },
  methods: {
    updateVModel(text){
      this.search = text;
    }
  }
}
</script>
